import {ValidatorFn, Validators} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import {TextAreaFieldConfig} from './text-area-field.config';
import {textTriggerSyntaxValidator} from '../../validation/text-trigger.validator';

export const textareaFieldControlBuilder: ControlBuilder = (fieldConfig: TextAreaFieldConfig, formBuilder) => {
    const {disabled, value} = fieldConfig;

    const validators = buildTextareaFieldValidators(fieldConfig);

    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: value || null
        },
        validators,
        asyncValidators
    );
};

export const buildTextareaFieldValidators: (fieldConfig: TextAreaFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);

        if (config.maxLength) {
            validators.push(Validators.maxLength(config.maxLength));
        }

        const autocomplete = config.autocompleteConfig;
        if (autocomplete && !autocomplete.ignoreValidation) {
            const triggerStart = autocomplete.triggerStart ?? '{{';
            const triggerEnd = autocomplete.triggerEnd ?? '}}';
            const validOptionValues = new Set<string>();
            (autocomplete.items ?? []).forEach((item) => validOptionValues.add(item.value));
            (autocomplete.groupedItems ?? []).forEach((group) => {(group.items ?? []).forEach((item) => validOptionValues.add(item.value));});
            validators.push(textTriggerSyntaxValidator(triggerStart, triggerEnd, validOptionValues));
        }

        return validators;
    };
